import { gql } from '@apollo/client';

export const GET_DELIVERY_PROGRESS_MONITORING_OF_SLA_LIST = gql`
  query GetDeliveryProgressMonitoringOfSlaList($filter: DeliveryProgressMonitoringOfSlaFilterTypeInput!) {
    getDeliveryProgressMonitoringOfSlaList(filter: $filter) {
      summaryData {
        parcelsSummary {
          totalParcels
          actualArrivals
          pickedCount
          deliveredLatest
          missScanWhsArrivalCount
          returnedParcelIncompleteOver72hRate
          failedReturnedToWhsUnprocessedOver24hRate
          parcelWithReturnStartTimeCount
          parcelWithReturnWarehouseScanCount
        }
        anomalyData {
          aboutToBreak {
            total48To72h
            warehouseSide48To72h
            driverSide48To72h
          }
          alreadyBreak {
            totalOver72h
            warehouseSideOver72h
            driverSideOver72h
          }
          overtime {
            unpicked12h
            undelivered24h
          }
        }
        pieChartData {
          unpicked
          failedNotReturned
          failedReturnedToWhs
          inDelivery
          returnedParcel
          lostDamaged
          driverSide
          warehouseSide
          handoverDiff
          returnedV2
        }
      }
      recordData {
        id
        warehouseId
        dspId
        areaId
        cityName
        actualArrivals
        pickedCount
        unpickedCount
        inProgress
        deliveredLatest
        failedIncomplete
        failedReturnedToWhsCount
        returnedParcelCount
        lostDamagedCount
        missScanWhsArrivalCount
        returnedParcelIncompleteOver72hCount
        parcelWithReturnStartTimeCount
        failedReturnedToWhsUnprocessedOver24hCount
        parcelWithReturnWarehouseScanCount
        returnedParcelIncompleteOver72hRate
        failedReturnedToWhsUnprocessedOver24hRate
        noUpdate72To120hReturnedCount
        noUpdateOver120hReturnedCount
        latestDeliveryRate
        t1DeliveryRate
        t2DeliveryRate
        t3DeliveryRate
        t4DeliveryRate
        t5DeliveryRate
        anomalyUnpicked24h
        anomalyUndelivered24h
        anomalyUndelivered48h
        anomalyUndelivered72h
        anomalyAboutToTimeout24h
        anomalyAboutToTimeout48h
        anomalyNoUpdate24h
        anomalyNoUpdate72h
        anomalyNoUpdate72To120h
        anomalyNoUpdateOver120h
        anomalyUnpicked12h
        warehouseName
        dspName
        areaName
      }
    }
  }
`;

export const GET_DELIVERY_PROGRESS_MONITORING_OF_SLA_PAGE_LIST = gql`
  query GetDeliveryProgressMonitoringOfSlaPageList($pageRequest: DeliveryProgressMonitoringOfSlaPageRequestTypeInput!) {
    getDeliveryProgressMonitoringOfSlaPageList(pageRequest: $pageRequest) {
      calculatedAt
      summaryData {
        parcelsSummary {
          totalParcels
          actualArrivals
          pickedCount
          deliveredLatest
          missScanWhsArrivalCount
          returnedParcelIncompleteOver72hRate
          failedReturnedToWhsUnprocessedOver24hRate
          parcelWithReturnStartTimeCount
          parcelWithReturnWarehouseScanCount
        }
        anomalyData {
          aboutToBreak {
            total48To72h
            warehouseSide48To72h
            driverSide48To72h
          }
          alreadyBreak {
            totalOver72h
            warehouseSideOver72h
            driverSideOver72h
          }
          overtime {
            unpicked12h
            undelivered24h
          }
        }
        pieChartData {
          unpicked
          failedNotReturned
          failedReturnedToWhs
          inDelivery
          returnedParcel
          lostDamaged
          driverSide
          warehouseSide
          handoverDiff
          returnedV2
        }
      }
      pageResponse {
        content {
          id
          warehouseId
          dspId
          areaId
          cityName
          driverId
          driverName
          arrivalPointType
          actualArrivals
          pickedCount
          unpickedCount
          inProgress
          deliveredLatest
          failedIncomplete
          failedReturnedToWhsCount
          returnedParcelCount
          lostDamagedCount
          missScanWhsArrivalCount
          returnedParcelIncompleteOver72hCount
          parcelWithReturnStartTimeCount
          failedReturnedToWhsUnprocessedOver24hCount
          parcelWithReturnWarehouseScanCount
          returnedParcelIncompleteOver72hRate
          failedReturnedToWhsUnprocessedOver24hRate
          noUpdate72To120hReturnedCount
          noUpdateOver120hReturnedCount
          latestDeliveryRate
          t1DeliveryRate
          t2DeliveryRate
          t3DeliveryRate
          t4DeliveryRate
          t5DeliveryRate
          anomalyUnpicked24h
          anomalyUndelivered24h
          anomalyUndelivered48h
          anomalyUndelivered72h
          anomalyAboutToTimeout24h
          anomalyAboutToTimeout48h
          anomalyNoUpdate24h
          anomalyNoUpdate72h
          anomalyNoUpdate72To120h
          anomalyNoUpdateOver120h
          anomalyUnpicked12h
          delivered36hCount
          driverSideLcCount
          warehouseSideLcCount
          handoverDiffLcCount
          returnLcCount
          outForDeliveryNodeLcCount
          failedNotReturnedNodeLcCount
          lostDamagedDriverLcCount
          returnOnPutAwayLcCount
          returnUnPutAwayLcCount
          returnNotPutAwayLcCount
          returnWrongScanLcCount
          notPickedUpLcCount
          missortedNodeLcCount
          lostDamagedWhsLcCount
          otherLcCount
          handoverDiffNodeLcCount
          returnWrongUnscanNodeLcCount
          inWhsNodeLcCount
          returnPkgLcCount
          warehouseName
          dspName
          areaName
          createdAt
          updatedAt
          calculatedAt
          isDeleted
        }
        page
        size
        totalElements
        totalPages
        hasNext
        hasPrevious
      }
    }
  }
`;

export const GET_DELIVERY_PROGRESS_MONITORING_OF_SLA_DETAIL_LIST = gql`
  query GetDeliveryProgressMonitoringOfSlaDetailList($pageRequest: DeliveryProgressMonitoringOfSlaDetailPageRequestTypeInput!) {
    getDeliveryProgressMonitoringOfSlaDetailList(pageRequest: $pageRequest) {
      content {
        id
        arrivalDate
        taskDate
        warehouseId
        areaId
        cityName
        trackingNumber
        orderId
        lastOperateDspId
        lastOperateDriverId
        lastAssignDspId
        lastAssignDriverId
        lastOperateDspName
        lastOperateDriverName
        lastAssignDspName
        lastAssignDriverName
        overallStatus
        overallStatusText
        isUnpicked24h
        isUndelivered24h
        isUndelivered48h
        isUndelivered72h
        isAboutToTimeout24h
        isAboutToTimeout48h
        isNoUpdate24h
        isNoUpdate72h
        isActualArrivals
        isInDelivery
        isDeliveredLatest
        isReturnedDamagedLost
        isLostDamaged
        isFailedIncomplete
        isReturnedParcelIncompleteOver72h
        isParcelWithReturnStartTime
        isFailedReturnedToWhsUnprocessedOver24h
        isParcelWithReturnWarehouseScan
        warehouseName
        areaName
        undeliveredReasonLevel1
        undeliveredReasonLevel2
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export type NoUpdateBreakType = 'NO_UPDATE_48_TO_72H' | 'NO_UPDATE_OVER_72H';

export const GET_BREAK_DRIVER_SIDE_BREAKDOWN = gql`
  query GetBreakDriverSideBreakdown(
    $breakType: NoUpdateBreakType!
    $filter: DeliveryProgressMonitoringOfSlaFilterTypeInput!
    $page: Int!
    $size: Int!
  ) {
    getBreakDriverSideBreakdown(breakType: $breakType, filter: $filter, page: $page, size: $size) {
      content {
        dspId
        dspName
        count
        drivers {
          driverId
          driverName
          count
        }
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export interface DriverCountItemType {
  driverId: number;
  driverName: string;
  count: number;
}

export interface DspDriverBreakdownItemType {
  dspId: number;
  dspName: string;
  count: number;
  drivers: DriverCountItemType[];
}

export interface BreakDriverSideBreakdownPageResponseType {
  content: DspDriverBreakdownItemType[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface GetBreakDriverSideBreakdownResponse {
  getBreakDriverSideBreakdown: BreakDriverSideBreakdownPageResponseType;
}

export interface DeliveryProgressMonitoringOfSlaFiltersType {
  hubId?: number; // 枢纽ID，Hub 页面必传；parcel 页面不传
  arrivalDateStart: string; // 到仓日期范围起始(YYYY-MM-DD)，单日时与 arrivalDateEnd 传同一天
  arrivalDateEnd: string; // 到仓日期范围结束(YYYY-MM-DD)
  warehouseIds?: number[]; // 仓库ID列表，后端 List<Long>；WHS/DSP 维度均生效
  dspIds?: number[];
  areaIds?: number[];
  cityNames?: string[];
  driverIds?: number[];
  arrivalPointType: number; // 到达节点类型：0-仓库(whs)，1-枢纽(hub)，必传
  dimension?: string; // area-区域维度，driver-司机维度，默认 area
}

export interface DeliveryProgressMonitoringOfSlaDetailFilterType {
  arrivalDateStart: string; // 到仓日期范围起始(YYYY-MM-DD)
  arrivalDateEnd: string;   // 到仓日期范围结束(YYYY-MM-DD)
  hubId?: number; // 枢纽ID，Hub 页面必传；parcel 页面不传
  warehouseIds: number[]; // 支持多个仓库ID
  dspIds?: number[]; // 支持多个DSP ID
  areaIds?: number[]; // 支持多个区域ID
  driverIds?: number[]; // 支持多个司机ID
  driverIdNullOnly?: boolean; // true 时仅查未分配司机(driver_id IS NULL)，与 driverIds 互斥
  cityNames?: string[]; // 支持多个城市名称
  trackingNumber?: string;
  statusField?: string;
  statusFields?: string[]; // 多选状态字段（OR 逻辑）
  undeliveredReasonLevel1?: string; // v2 未妥投归因一级
  undeliveredReasonLevel2?: string; // v2 未妥投归因二级
  ids?: string[]; // 主键ID列表（用于选中数据下载）
  arrivalPointType: number; // 到达节点类型：0-仓库(whs)，1-枢纽(hub)，必传；明细与一级汇总一致
}

export interface DeliveryProgressMonitoringOfSlaDetailPageRequestType {
  filter: {
    arrivalDateStart: string; // 到仓日期范围起始(YYYY-MM-DD)
    arrivalDateEnd: string;   // 到仓日期范围结束(YYYY-MM-DD)
    hubId?: number; // 枢纽ID，Hub 页面必传；parcel 页面不传
    warehouseIds: number[]; // 支持多个仓库ID，后端 List<Long>
    dspIds?: number[]; // 支持多个DSP ID
    areaIds?: number[]; // 支持多个区域ID
    driverIds?: number[]; // 支持多个司机ID
    driverIdNullOnly?: boolean; // true 时仅查未分配司机，与 driverIds 互斥
    cityNames?: string[]; // 支持多个城市名称
    trackingNumber?: string;
    statusField?: string;
    statusFields?: string[]; // 多选状态字段（OR 逻辑）
    undeliveredReasonLevel1?: string; // v2 未妥投归因一级
    undeliveredReasonLevel2?: string; // v2 未妥投归因二级
    arrivalPointType: number; // 到达节点类型：0-whs，1-hub，必传；与一级汇总一致
  };
  page: number;
  size: number;
  sortBy?: string;
  sortDirection?: string;
}

export interface DeliveryProgressMonitoringOfSlaType {
  id?: string;
  warehouseId: string;
  dspId: number;
  areaId?: number;
  cityName?: string;
  driverId?: number;
  driverName?: string;
  arrivalPointType?: number;
  actualArrivals: number;
  pickedCount: number;
  unpickedCount: number;
  inProgress: number;
  deliveredLatest: number;
  failedIncomplete: number;
  failedReturnedToWhsCount: number;
  returnedParcelCount: number;
  lostDamagedCount: number;
  missScanWhsArrivalCount: number;
  returnedParcelIncompleteOver72hCount?: number;
  parcelWithReturnStartTimeCount?: number;
  failedReturnedToWhsUnprocessedOver24hCount?: number;
  parcelWithReturnWarehouseScanCount?: number;
  returnedParcelIncompleteOver72hRate?: string;
  failedReturnedToWhsUnprocessedOver24hRate?: string;
  noUpdate72To120hReturnedCount: number;
  noUpdateOver120hReturnedCount: number;
  latestDeliveryRate: string;
  t1DeliveryRate: string;
  t2DeliveryRate: string;
  t3DeliveryRate: string;
  t4DeliveryRate: string;
  t5DeliveryRate: string;
  anomalyUnpicked24h: number;
  anomalyUndelivered24h: number;
  anomalyUndelivered48h: number;
  anomalyUndelivered72h: number;
  anomalyAboutToTimeout24h: number;
  anomalyAboutToTimeout48h: number;
  anomalyNoUpdate24h: number;
  anomalyNoUpdate72h: number;
  anomalyNoUpdate72To120h: number;
  anomalyNoUpdateOver120h: number;
  anomalyUnpicked12h: number;
  delivered36hCount?: number;
  driverSideLcCount?: number;
  warehouseSideLcCount?: number;
  handoverDiffLcCount?: number;
  returnLcCount?: number;
  outForDeliveryNodeLcCount?: number;
  failedNotReturnedNodeLcCount?: number;
  lostDamagedDriverLcCount?: number;
  returnOnPutAwayLcCount?: number;
  returnUnPutAwayLcCount?: number;
  returnNotPutAwayLcCount?: number;
  returnWrongScanLcCount?: number;
  notPickedUpLcCount?: number;
  missortedNodeLcCount?: number;
  lostDamagedWhsLcCount?: number;
  otherLcCount?: number;
  handoverDiffNodeLcCount?: number;
  returnWrongUnscanNodeLcCount?: number;
  inWhsNodeLcCount?: number;
  returnPkgLcCount?: number;
  warehouseName?: string;
  dspName?: string;
  areaName?: string;
  calculatedAt?: string;
}

export interface DeliveryProgressMonitoringOfSlaDetailType {
  id?: string;
  arrivalDate: string;
  taskDate: string;
  warehouseId: string;
  dspId: number;
  areaId: number;
  cityName: string;
  trackingNumber: string;
  orderId: number;
  lastOperateDspId?: number;
  lastOperateDriverId?: number;
  lastAssignDspId?: number;
  lastAssignDriverId?: number;
  lastOperateDspName?: string;
  lastOperateDriverName?: string;
  lastAssignDspName?: string;
  lastAssignDriverName?: string;
  driverId?: number;
  deliveryDriverId?: number;
  overallStatus?: number;
  overallStatusText?: string;
  isUnpicked24h?: boolean;
  isUndelivered24h?: boolean;
  isUndelivered48h?: boolean;
  isUndelivered72h?: boolean;
  isAboutToTimeout24h?: boolean;
  isAboutToTimeout48h?: boolean;
  isNoUpdate24h?: boolean;
  isNoUpdate72h?: boolean;
  isActualArrivals?: boolean;
  isInDelivery?: boolean;
  isDeliveredLatest?: boolean;
  isReturnedDamagedLost?: boolean;
  isLostDamaged?: boolean;
  isFailedIncomplete?: boolean;
  isReturnedParcelIncompleteOver72h?: boolean;
  isParcelWithReturnStartTime?: boolean;
  isFailedReturnedToWhsUnprocessedOver24h?: boolean;
  isParcelWithReturnWarehouseScan?: boolean;
  warehouseName?: string;
  areaName?: string;
  driverAccountName?: string;
}

export interface MonitoringParcelsSummaryType {
  totalParcels: number;
  actualArrivals: number;
  pickedCount: number;
  deliveredLatest: number;
  missScanWhsArrivalCount: number;
  returnedParcelIncompleteOver72hRate?: string;
  failedReturnedToWhsUnprocessedOver24hRate?: string;
  parcelWithReturnStartTimeCount?: number;
  parcelWithReturnWarehouseScanCount?: number;
}

export interface PieChartDataType {
  unpicked: number;
  failedNotReturned: number;
  failedReturnedToWhs: number;
  inDelivery: number;
  returnedParcel: number;
  lostDamaged: number;
  driverSide: number;
  warehouseSide: number;
  handoverDiff: number;
  returnedV2: number;
}

export interface AnomalyDataType {
  aboutToBreak: AboutToBreakDataType;
  alreadyBreak: AlreadyBreakDataType;
  overtime: OvertimeDataType;
}

export interface AboutToBreakDataType {
  total48To72h: number;
  warehouseSide48To72h: number;
  driverSide48To72h: number;
}

export interface AlreadyBreakDataType {
  totalOver72h: number;
  warehouseSideOver72h: number;
  driverSideOver72h: number;
}

export interface OvertimeDataType {
  unpicked12h: number;
  undelivered24h: number;
}

export interface DeliveryProgressMonitoringOfSlaSummaryType {
  parcelsSummary: MonitoringParcelsSummaryType;
  anomalyData: AnomalyDataType;
  pieChartData: PieChartDataType;
}

export interface DeliveryProgressMonitoringOfSlaResponseType {
  summaryData: DeliveryProgressMonitoringOfSlaSummaryType;
  recordData: DeliveryProgressMonitoringOfSlaType[];
}

export interface DeliveryProgressMonitoringOfSlaPageRequestType {
  filter: DeliveryProgressMonitoringOfSlaFiltersType;
  pageRequest: {
    page: number;
    size: number;
    sortBy?: string;
    sortDirection?: string;
  };
}

export interface DeliveryProgressMonitoringOfSlaPageResponseType {
  calculatedAt?: string;
  summaryData: DeliveryProgressMonitoringOfSlaSummaryType;
  pageResponse: {
    content: DeliveryProgressMonitoringOfSlaType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
  };
}

export interface DeliveryProgressMonitoringOfSlaDetailPageResponseType {
  content: DeliveryProgressMonitoringOfSlaDetailType[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
  filterOptions?: {
    cities: string[];
    dsps: Array<{
      id: number;
      name: string;
    }>;
    areas: Array<{
      id: number;
      name: string;
    }>;
    drivers: Array<{
      id: number;
      name: string;
    }>;
  };
}

export interface GetDeliveryProgressMonitoringOfSlaListResponse {
  getDeliveryProgressMonitoringOfSlaList: DeliveryProgressMonitoringOfSlaResponseType;
}

export interface GetDeliveryProgressMonitoringOfSlaPageListResponse {
  getDeliveryProgressMonitoringOfSlaPageList: DeliveryProgressMonitoringOfSlaPageResponseType;
}

export interface GetDeliveryProgressMonitoringOfSlaDetailListResponse {
  getDeliveryProgressMonitoringOfSlaDetailList: DeliveryProgressMonitoringOfSlaDetailPageResponseType;
}

